import React from 'react';
import { DynamicObjectType } from 'types/commons';

const CustomerLabel = ({
  data,
  sizeClass,
}: {
  data: DynamicObjectType;
  sizeClass?: string;
}) => {
  return (
    <div style={{ minWidth: 120 }}>
      <div
        className={`text-title-gray ${sizeClass || 'text-xs'} fw-400`}
      >{`${data?.firstName || ''} ${data?.lastName || ''}`}</div>
      <div className={`text-secondary ${sizeClass || 'text-xs'} fw-400`}>
        {data?.email}
      </div>
    </div>
  );
};

export default CustomerLabel;
